export default [
  {
    path: '/events',
    name: 'events',
    component: () => import('@/views/Public/Events'),
    meta: {}
  }
];
